import { Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { UserContext } from "contexts/UserContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { pettyCashApiNm, pettyCashColNm } from "./constant"
import ComboBox from "components/ComboBox"
import { alertError, alertSuccess, alertWarning } from "components/Alert"
import { CancelRounded, CheckCircleRounded, PrintRounded, SaveRounded, AutoAwesomeRounded } from "resource/muiImport"
import { expensePOIApiNm } from "pages/Menu4/ExpensePOI/constant"
import { red, green, grey } from "@mui/material/colors"
import { expenseJobOrderColNm } from "constants/expenseJobOrderConstant"
import { bahtProps, percentProps } from "utils/bahtProps"
import { jobOrderApiNm } from "constants/jobOrderConstant"
import { selectOnFocus } from "utils"
import { getDataAndPrintWht } from "utils/getDataAndPrintWht"
import ExpensePOIDialog from "pages/Menu4/ExpensePOI/ExpensePOIDialog"
import PopoverSearchJobOrder from "components/PopoverSerachJobOrder/PopoverSearchJobOrder"
import dayjs from "dayjs"

// const initWhtPrintData = {
//   WhtPayrTyp: "A",
//   WhtTyp: 5,
//   WhtTypOthTxt: "",
//}

let isPreventUpdateAmnt = false

let initExpensePOIData = null

let suggessPOIIds = null

const calculateAfterWhtPrct = (amnt, vatPrct, whtPrct) => {
  return amnt / (1 + vatPrct / 100) * (1 - whtPrct / 100) + amnt / (1 + vatPrct / 100) * vatPrct / 100
}

const PayComponent = ({ dialogOpen, dialogData, setDialogData, isItemDialog, isRequriedUsrAccId
  , usrAccId, jobOrdId, isHideJobOrdId, suggestUsrAccIds, updLnkSiteAbbr }) => {
  const { user } = useContext(UserContext)
  const { msData, ax } = useContext(GlobalStateContext)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingUntPr, setIsLoadingUntPr] = useState(false)
  // const [IsShowPrintWht, setShowPrintWht] = useState(false)
  // const [whtPrintData, setWhtPrintData] = useState({ ...initWhtPrintData })
  const [dialogExpensePOIOpen, setDialogExpensePOIOpen] = useState(false)


  const usrAccCombo = useMemo(() => {
    if (!suggestUsrAccIds || suggestUsrAccIds.length === 0) return msData.accountAllCombo
    const result = []
    for (const acc of msData.accountAllCombo) {
      if (suggestUsrAccIds.includes(acc.id)) {
        result.unshift({ ...acc, group: "แนะนำ" })
      } else {
        result.push({ ...acc })
      }
    }
    return result
  }, [suggestUsrAccIds, msData.accountAllCombo])

  // const whtPrintTextFieldProps = useCallback((name) => ({
  //   size: "small",
  //   value: whtPrintData[name],
  //   onChange: (e) => { setWhtPrintData(o => ({ ...o, [name]: e.target.value })) }
  // }), [whtPrintData])

  const textFieldProps = useCallback((name, isRequired) => ({
    fullWidth: true,
    required: isRequired,
    label: pettyCashColNm[name],
    size: "small",
    error: isRequired && !dialogData[name],
    value: dialogData[name] ?? "",
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData, setDialogData])

  const handleDateTimeBlur = useCallback((value) => {
    if (!dayjs(value).isValid()) {
      alertWarning("รูปแบบวันที่ไม่ถูกต้อง")
    } else {
      const valueYear = dayjs(value).year()
      if (valueYear > dayjs().year() + 1 || valueYear < dayjs().year() - 1) {
        alertWarning("คำเตือน: ปีของวันที่ที่ระบุอาจไม่ถูกต้อง")
      }
    }
  }, [])
  const dateTimePickerProp = useCallback((name, isRequired) => ({
    label: pettyCashColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm:ss",
    mask: "__/__/____ __:__:__",
    value: dialogData[name],
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField size="small" {...params}
      fullWidth required={isRequired}
      error={!dayjs(dialogData[name]).isValid() || (isRequired && !dialogData[name])}
      onBlur={() => handleDateTimeBlur(dialogData[name])} />,
  }), [dialogData, setDialogData, handleDateTimeBlur])

  const comboboxProps = useCallback((nameId, nameNm, options) => ({
    label: pettyCashColNm[nameId],
    sx: { width: "100%" },
    options: options,
    selectedId: dialogData[nameId],
    setSelectedId: (id) => setDialogData(o => ({ ...o, [nameId]: id, [nameNm]: options.find(option => option.id === id)?.label })),
  }), [dialogData, setDialogData])

  const setUntPrByJobOrdIdExpId = useCallback((jobOrdId, expId) => {
    console.log("dialogData:: ", dialogData.PCItmId, dialogData.PCTrnsId, isItemDialog);
    if (isItemDialog && dialogData.PCItmId) return

    if (!isItemDialog && dialogData.PCTrnsId) return

    if (isPreventUpdateAmnt) return

    if (dialogData.PCPrdId) return

    if (expId) {

      setIsLoadingUntPr(true)
      const postData = {
        JobOrdId: jobOrdId || null,
        ExpId: expId || null,
        UpdLnkSiteAbbr: updLnkSiteAbbr
      }
      ax.post(expensePOIApiNm.getUntPrByJobOrdIdExpId, postData, false).then(value => {
        setIsLoadingUntPr(false)
        if (value.data && value.data.length === 1) {
          setDialogData(o => ({
            ...o,
            Amnt: value.data[0].UntPr,
            VatPrct: value.data[0].VatPrct,
            WhtPrct: value.data[0].WhtPrct,
            IsOwnRcpt: value.data[0].IsOwnRcpt,
            IsCost: o.InOutTyp === "O" ? value.data[0].IsCost : o.IsCost,
          }))
        } else {
          const expObj = msData.expObj[expId]
          setDialogData(o => ({
            ...o,
            Amnt: expObj.UntPr,
            VatPrct: expObj.VatPrct,
            WhtPrct: expObj.WhtPrct,
            IsOwnRcpt: expObj.IsOwnRcpt,
            IsCost: o.InOutTyp === "I" ? 1 : expObj.IsCost,
          }))
        }
      })
    }
  }, [ax, setDialogData, dialogData.PCPrdId, msData.expObj, updLnkSiteAbbr
    , isItemDialog, dialogData.PCItmId, dialogData.PCTrnsId
  ])

  const handleJobOrdIdBlur = useCallback((e) => {
    if (e.target.value === "") {
      setDialogData(o => ({
        ...o,
        LocText: "",
        isJobOrdIdCorrect: null,
      }))
      return
    }
    setIsLoading(true)
    const postData = {
      JobOrdId: e.target.value,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    ax.post(pettyCashApiNm.getJobOrderLocation, postData, false).then(value => {
      setIsLoading(false)
      if (value.data) {
        if (value.data.length !== 1) {
          setDialogData(o => ({
            ...o,
            LocText: "",
            isJobOrdIdCorrect: false,
          }))
          alertError("ไม่พบข้อมูล เลขที่ใบงานนี้")
          return
        } else {
          const data = value.data[0]
          setDialogData(o => ({
            ...o,
            ...data,
            isJobOrdIdCorrect: true,
            LocText: `(${data.ContSizeFull || ""})${data.TakePlc || ""}-${data.Loc || ""}-${data.RtnPlc || ""}`
          }))
          if (dialogData.ExpId) {
            setUntPrByJobOrdIdExpId(e.target.value, dialogData.ExpId)
          }
        }
      }
    })
  }, [ax, setDialogData, dialogData.ExpId, setUntPrByJobOrdIdExpId, updLnkSiteAbbr])


  const handleExpChange = useCallback((id) => {

    setDialogData(o => {
      setUntPrByJobOrdIdExpId(o.JobOrdId, id)
      return { ...o, ExpId: id }
    })
  }, [setDialogData, setUntPrByJobOrdIdExpId])

  const calculatePayAmnt = useCallback(() => {
    isPreventUpdateAmnt = true

    setDialogData(o => {
      const amnt = +(o.Amnt || 0)
      const vatPrct = +(o.VatPrct || 0)
      const whtPrct = +(o.WhtPrct || 0)
      const payAmnt = calculateAfterWhtPrct(amnt, vatPrct, whtPrct)
      return { ...o, PayAmnt: payAmnt.toFixed(2) }
    })
  }, [setDialogData])

  const handlePrintWht = useCallback(() => {
    console.log("handlePrintWht dialogData", dialogData);
    getDataAndPrintWht({
      ax, user,
      dialogData,
      companyData: msData.serverData.CompanyData,
      updLnkSiteAbbr
    })
  }, [ax, dialogData, msData.serverData.CompanyData, updLnkSiteAbbr, user])

  const handleSaveExpensePOI = useCallback(async () => {
    initExpensePOIData = {
      ExpPOIId: null,
      IsCost: dialogData.IsCost,
      ExpId: dialogData.ExpId,
      VatPrct: dialogData.VatPrct,
      WhtPrct: dialogData.WhtPrct,
      UntPr: dialogData.Amnt,
      IsOwnRcpt: dialogData.IsOwnRcpt,
      Prty: 50,
      JobId: null,
      CusId: null,
      POIId: null,
      ContSize: "",
      ContTyp: "",
      ShpmTypId: null,
      TlrTypId: null,
      Rmk: ""
    }
    suggessPOIIds = null

    if (dialogData.JobOrdId) {
      const postData = {
        JobOrdId: dialogData.JobOrdId,
        UpdLnkSiteAbbr: updLnkSiteAbbr
      }
      const res = await ax.post(jobOrderApiNm.getJobOrder, postData)
      if (res.data && res.data.length > 0) {
        const data = res.data[0]
        initExpensePOIData = {
          ...initExpensePOIData,
          JobId: data.Shipment.JobId,
          CusId: data.Shipment.CusId,
          POIId: data.LocPOIId,
          ContSize: data.ContSize,
          ContTyp: data.ContTyp,
          ShpmTypId: data.ShpmTypId,
          TlrTypId: data.TlrTypId,
        }
        if (data.TakePOIId || data.LocPOIId || data.RtnPOIId) {
          suggessPOIIds = []
          data.TakePOIId && suggessPOIIds.push(data.TakePOIId)
          data.LocPOIId && suggessPOIIds.push(data.LocPOIId)
          data.RtnPOIId && suggessPOIIds.push(data.RtnPOIId)
        }
      }
    }

    setDialogExpensePOIOpen(true)
  }, [dialogData, ax, updLnkSiteAbbr])

  const onExpensePOIFinish = useCallback((data) => {
    if (data) {
      alertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว")
    }
  }, [])

  const handleSelectJobOrder = useCallback((item) => {
    setDialogData(o => ({
      ...o,
      JobOrdId: item.JobOrdId,
      LocText: `(${item.ContSizeFull || ""})${msData.poiObj[item.TakePOIId] || ""}-${msData.poiObj[item.LocPOIId] || ""}-${msData.poiObj[item.RtnPOIId] || ""}`,
      isJobOrdIdCorrect: true
    }))
    setUntPrByJobOrdIdExpId(item.JobOrdId, dialogData.ExpId)
  }, [msData.poiObj, setDialogData, setUntPrByJobOrdIdExpId, dialogData.ExpId])

  const handleDocNoBlur = useCallback((e) => {
    // console.log("checkDocNoExist e.target.value:: ", e.target.value);
    if (!e.target.value) return
    ax.post(pettyCashApiNm.checkDocNoExist, { DocNo: e.target.value }, false).then(value => {
      if (value.data) {
        if (value.data.length > 0) {
          alertWarning(`เลขที่เอกสาร ${e.target.value} มีอยู่ในระบบแล้ว กรุณาตรวจสอบ`)
        }
      }
    })
  }, [ax])

  const handleIsCostChange = useCallback((e) => {
    const value = e.target.value
    setDialogData(o => ({
      ...o,
      IsCost: value,
      IsOwnRcpt: value
    }))
  }, [setDialogData])
  useEffect(() => {
    isPreventUpdateAmnt = false
  }, [dialogOpen])


  // console.log("dialgData", dialogData);
  return (
    <BoxFC width={400} sx={{ gap: 1 }}>
      <BoxFR width="100%">
        {!isItemDialog &&
          <ComboBox {...comboboxProps("UsrAccId", "UsrNNm", usrAccCombo)}
            required={isRequriedUsrAccId ?? false}
            selectedId={dialogData.UsrAccId} />
        }
        <DateTimePickerCustomTime {...dateTimePickerProp("PayTm", true)} disabled={dialogData.PCPrdId ? true : false} />
      </BoxFR>
      {isHideJobOrdId ? null :
        <BoxFR>
          <TextField {...textFieldProps("JobOrdId")} disabled={jobOrdId ? true : false}
            onBlur={handleJobOrdIdBlur} type="number"
            onChange={(e) => setDialogData(o => ({ ...o, JobOrdId: e.target.value || null }))}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  {isLoading ? <CircularProgress size={20} />
                    : !dialogData.JobOrdId || dialogData.isJobOrdIdCorrect === null ? null
                      : dialogData.isJobOrdIdCorrect ? <CheckCircleRounded color="success" /> : <CancelRounded color="error" />}
                </InputAdornment>,
              startAdornment:
                <InputAdornment position="start">
                  <PopoverSearchJobOrder
                    handleSelectJobOrder={handleSelectJobOrder}
                    suggestDrvId={dialogData.UsrAccId} />
                </InputAdornment>
            }} />
          <TextField {...textFieldProps("LocText")} onChange={null}
            inputProps={{ style: { fontSize: "0.8em" } }} />
        </BoxFR>
      }

      <BoxFR>
        <ComboBox {...comboboxProps("ExpId", "ExpNm", msData.expOprCombo)}
          setSelectedId={handleExpChange}
          required={true} />
        <TextField {...textFieldProps("Amnt", true)} type="number" disabled={isLoadingUntPr || dialogData.PCPrdId ? true : false}
          onBlur={calculatePayAmnt}
          onFocus={selectOnFocus}
          inputProps={{ style: { textAlign: "right" } }}
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                {isLoadingUntPr ? <CircularProgress size={20} /> : "บาท"}
              </InputAdornment>
          }} />
      </BoxFR>
      <BoxFR>
        <TextField {...textFieldProps("VatPrct")} type="number" {...percentProps} onBlur={calculatePayAmnt} onFocus={selectOnFocus} />
        <TextField {...textFieldProps("WhtPrct")} type="number"

          inputProps={{ style: { textAlign: "right" } }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
            startAdornment: <InputAdornment position="start">
              <IconButton sx={{ p: 0 }} onClick={() => { 
                setDialogData(o => ({ ...o, VatPrct: 7, WhtPrct: 3, PayAmnt: calculateAfterWhtPrct(o.Amnt, 7, 3).toFixed(2) })) }}>
                <AutoAwesomeRounded />
              </IconButton>
            </InputAdornment>
          }}

          disabled={dialogData.PCPrdId ? true : false}
          onBlur={calculatePayAmnt}
          onFocus={selectOnFocus} />
      </BoxFR>
      {dialogData.WhtPrct > 0 ?
        <BoxFR>
          <TextField {...textFieldProps("WhtPayrTyp")} fullWidth={false} label="ผู้หัก ณ ที่จ่าย" select >
            <MenuItem value={"A"}>กระทำการแทน</MenuItem>
            <MenuItem value={"O"}>บริษัททำการหัก</MenuItem>
            <MenuItem value={"C"}>ลูกค้าทำการหัก</MenuItem>
          </TextField>
          <TextField {...textFieldProps("WhtTypId")} fullWidth={false} label="ประเภทหัก" select sx={{flex: 1}}>
            {msData.whtTypeCombo?.map((option) => (
              <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
            ))}
            {/* <MenuItem value={0}>อื่นๆ</MenuItem> */}
          </TextField>
          {dialogData.WhtTypId === 6 ?
            <TextField {...textFieldProps("WhtTypOthTxt")} fullWidth={false} label="รายละเอียดอื่นๆ" sx={{ width: 100 }} />
            : null
          }
          {/* <TextField {...whtPrintTextFieldProps("WhtTypOthTxt")} label="รายละเอียดอื่นๆ" 
            disabled={whtPrintData.WhtTyp === 5? true:false}/> */}
          <Button variant="contained" onClick={handlePrintWht}><PrintRounded sx={{ mr: 1 }} />พิมพ์</Button>
          {/* <Button variant="contained" color="inherit" sx={{ minWidth: 0, px: 0, }}
            onClick={e => { setDialogData(o => ({ ...o, IsShowPrintWht: false })) }}><CloseRounded /></Button> */}
        </BoxFR> : null
      }
      <BoxFR>
        <TextField {...textFieldProps("IsCost")} label="การวางบิลลูกค้า"
          onChange={handleIsCostChange}
          disabled={dialogData.InOutTyp === "I"}
          select sx={{
            bgcolor: dialogData.InOutTyp === "I" ? grey[100] : dialogData.IsCost === 1 ? red[50] : green[50]
          }}>
          <MenuItem value={0}>วางบิลได้(รายได้)</MenuItem>
          <MenuItem value={1}>วางบิลไม่ได้(ต้นทุน)</MenuItem>
        </TextField>
        <TextField {...textFieldProps("PayAmnt")} type="number"{...bahtProps} disabled />
      </BoxFR>
      {isItemDialog &&
        <BoxFR>
          <TextField {...textFieldProps("DocNo")} onBlur={handleDocNoBlur} />
          <DateTimePickerCustomTime {...dateTimePickerProp("DocDte")} inputFormat={"DD/MM/YYYY"} mask={"__/__/____"} />
        </BoxFR>
      }
      <TextField {...textFieldProps("Dscp")} />
      {
        !dialogData.IsCost &&

        <FormControl component="fieldset">
          <FormLabel component="legend">{expenseJobOrderColNm.IsOwnRcpt}</FormLabel>
          <RadioGroup row name='IsOwnRcpt' value={dialogData.IsOwnRcpt}
            onChange={(e) => { setDialogData((oldState) => ({ ...oldState, IsOwnRcpt: e.target.value })) }}>
            <FormControlLabel value={1} control={<Radio />} label="ใบเสร็จบริษัท" />
            <FormControlLabel value={0} control={<Radio />} label="ใบเสร็จลูกค้า" />
          </RadioGroup>
        </FormControl>
      }
      <BoxFR>
        {isItemDialog ?
          <ComboBox {...comboboxProps("SupId", "SName", msData.supplierCombo)} required={false} />
          :
          <ComboBox {...comboboxProps("PCJnlId", "PCJnlNm", msData.pcJournalCombo)} required={true}
            disabled={dialogData.PCPrdId ? true : false} />
        }
        <TextField {...textFieldProps("CtrlCd")} />
      </BoxFR>
      <BoxFR>
        {isItemDialog ? null :
          <ComboBox {...comboboxProps("SupId", "SName", msData.supplierCombo)} required={false} />
        }
        <TextField {...textFieldProps("Rmk")} />
      </BoxFR>
      {/* <BoxFR>
        {!dialogData.IsShowPrintWht ?
          <Button variant="contained" onClick={e => { setDialogData((o) => ({ ...o, IsShowPrintWht: !o.IsShowPrintWht })) }} disabled={dialogData.JobOrdId ? false : true}>
            <PrintRounded sx={{ mr: 1 }} />บันทึก/พิมพ์ใบหัก ณ ที่จ่าย</Button>
          : <BoxFR>
            <TextField {...textFieldProps("WhtPayrTyp")} fullWidth={false} label="ผู้หัก ณ ที่จ่าย" select >
              <MenuItem value={"A"}>กระทำการแทน</MenuItem>
              <MenuItem value={"O"}>บริษัททำการหัก</MenuItem>
              <MenuItem value={"C"}>ลูกค้าทำการหัก</MenuItem>
            </TextField>
            <TextField {...textFieldProps("WhtTypId")} fullWidth={false} label="ประเภทหัก" select >
              {msData.whtTypeCombo?.map((option) => (
                <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
              ))}
            </TextField>
            {dialogData.WhtTypId === 6 ?
              <TextField {...textFieldProps("WhtTypOthTxt")} fullWidth={false} label="รายละเอียดอื่นๆ" sx={{ width: 100 }} />
              : null
            }
            <Button variant="contained" onClick={handlePrintWht}><PrintRounded sx={{ mr: 1 }} />พิมพ์</Button>
            <Button variant="contained" color="inherit" sx={{ minWidth: 0, px: 0, }}
              onClick={e => { setDialogData(o => ({ ...o, IsShowPrintWht: false })) }}><CloseRounded /></Button>
          </BoxFR>
        }
      </BoxFR> */}
      <BoxFR>
        <Typography ><strong>ผู้ทำรายการ: </strong> {user.NName} </Typography>
        <Box flex={1} />
        <Button size="small" onClick={handleSaveExpensePOI}><SaveRounded sx={{ mr: 1 }} /> บันทึกข้อมูลใน 4.3</Button>
      </BoxFR>
      <ExpensePOIDialog
        dialogOpen={dialogExpensePOIOpen}
        setDialogOpen={setDialogExpensePOIOpen}
        selectedId={null}
        lastFilter={null}
        onFinish={onExpensePOIFinish}
        initData={initExpensePOIData}
        suggessPOIIds={suggessPOIIds}
      />
    </BoxFC>
  )
}

export default PayComponent